import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.Dropdown),
  () => import('./Dropdown'),
  (Dropdown) => {
    ComponentUtil.binder(Hooks.Dropdown, Dropdown);
  },
);
